import { ReactFC } from '../types'
import { useNavigation, useScreenKey } from './profile.selectors'

import PageTransitions from '../transitions/transitions'
import {
    NO_TRANSITION,
    TRANSITION_TO_MODAL,
    TRANSITION_FROM_MODAL
} from '../transitions/app-transitions'
import { getNextTransition, getPreviousTransition } from '../transitions/next-prev'
import React from 'react'


const getTransition = (fromStack, toStack) => {
    let transition = NO_TRANSITION

    if (fromStack) {
        let fromLevel = fromStack[fromStack.length - 1]
        let fromPlace =
            fromLevel && fromLevel.length && fromLevel[fromLevel.length - 1]
        let toLevel = toStack[toStack.length - 1]
        let toPlace = toLevel[toLevel.length - 1]
        if (fromPlace.next === toPlace.type) {
            transition = getNextTransition()
        } else {
            if (toPlace.next === fromPlace.type) {
                transition = getPreviousTransition()
            } else {
                if (toPlace.modal) {
                    if (fromPlace && fromPlace.modal) {
                        transition =
                            fromStack.length > toStack.length
                                ? TRANSITION_FROM_MODAL
                                : TRANSITION_TO_MODAL
                    } else {
                        if (
                            fromStack.length > toStack.length &&
                            fromStack[toStack.length - 1][0].type === toPlace.type
                        ) {
                            transition = NO_TRANSITION // to-place is actually a first sibling, slide left in TertiaryDivision
                        } else {
                            transition = TRANSITION_TO_MODAL
                        }
                    }
                } else {
                    if (fromPlace && fromPlace.modal) {
                        if (
                            toStack.length > fromStack.length &&
                            toStack[fromStack.length - 1][0].type === fromPlace.type
                        ) {
                            transition = NO_TRANSITION // from-place is actually a first sibling, slide right in TertiaryDivision
                        } else {
                            transition = TRANSITION_FROM_MODAL
                        }
                    } else {
                        let fromRoot = fromStack[0] ? fromStack[0][0] : undefined
                        let toRoot = toStack[0][0]
                        if (fromRoot && fromRoot.type !== toRoot.type && toRoot.modal) {
                            transition = TRANSITION_TO_MODAL
                        } else {
                            if (fromRoot && fromRoot.type !== toRoot.type && fromRoot.modal) {
                                transition = TRANSITION_FROM_MODAL
                            } else {
                                // slide left/right when primary/secondary nav change
                                // is handled within top/mid level screens
                            }
                        }
                    }
                }
            }
        }
    }

    if (transition === TRANSITION_FROM_MODAL || transition === TRANSITION_TO_MODAL) {
        transition = NO_TRANSITION
    }
    return transition
}

export const AppTransitions: ReactFC = ({ children }) => {
    // const navigation = useNavigation()
    // const { stack, prev } = navigation
    // const transition = getTransition(prev?.stack, stack)
    // const screenKey = useScreenKey()
    return children
    // if(NO_TRANSITION === transition) {
    //     return children
    // }
    // return (
    //     <PageTransitions {...transition} id={screenKey}>
    //         {children}
    //     </PageTransitions>
    // )
}